import styles from './Section.css'

const Section = props => {
  const {
    title,
    children
  } = props
  return (
    <section className={styles.Section}>
      <h2 className={styles.title}>{title}</h2>
      {children}
    </section>
  )
}

export default Section
